module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickExerBasket($event)
      }
    }
  }, [_c('div', {
    staticClass: "content-top",
    style: ({
      height: ((_vm.userInfo.role && _vm.userInfo.role.roleCode != 'student') ? '' : '80px')
    })
  }, [_c('Headers', {
    attrs: {
      "leave": _vm.leave
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-bottom",
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      },
      "click": function($event) {
        $event.stopPropagation();
        return _vm.leave()
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "enter-transition",
      "leave-active-class": "leave-transition"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', [_c('help', {
    ref: "help"
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3328660e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Home.vue
// module id = 548
// module chunks = 93